/**
 * The Sketch's words for the server's refusals of a roof as drawn (phase 6): never the request's field paths
 * ("sketch.dormers.0: …", developer text, docs/contributing/user-facing-messages.md), but what is wrong on the map and
 * what to do. Pure (tested in messages.test.ts); hooks.ts `sketchErrorText` applies it to API errors.
 */
import type { Text } from "./text.ts";

export interface FieldProblem {
  loc?: (string | number)[] | null;
  msg: string;
}

export function sketchProblemText(tx: Text, message: string, errors?: FieldProblem[] | null): string {
  const first = (errors ?? [])[0];
  const loc = (first?.loc ?? []).map(String);
  if (loc[0] === "sketch" && loc[1] === "dormers")
    return tx.t("sketch.problem.dormer", { n: Number(loc[2] ?? 0) + 1 });
  if (loc[0] === "sketch" && loc[1] === "structures") return tx.t("sketch.problem.structure");
  if (loc[0] === "sketch") return tx.t("sketch.problem.roof");
  if (loc[0] === "panels") return tx.t("sketch.problem.panels");
  return message;
}
